<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex>
        <card-carregando v-if="loading" />
        <v-card
          v-else
        >
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
          </v-toolbar>
          <v-flex
            text-xs-center
            title
            indigo--text
            mt-5
            mb-3
            mx-4
          >
            INDICAÇÃO DE REPRESENTANTES DE CONSELHOS PARA VOTAÇÃO NACIONAL
          </v-flex>
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-tabs
                  v-model="tabs"
                  centered
                  icons-and-text
                  show-arrows
                >
                  <v-tab
                    v-for="(indicado, index) in indicadosConselho"
                    :key="indicado.co_indicado_conselho"
                    :href="`#tab-${index+1}`"
                  >
                    {{ index+1 }}º Representante
                    <v-icon
                      center
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-tab>
                </v-tabs>
                <v-tabs-items
                  v-model="tabs"
                >
                  <v-tab-item
                    v-for="(indicado, index) in indicadosConselho"
                    :key="indicado.co_indicado_conselho"
                    :value="`tab-${index+1}`"
                  >
                    <indicacao-conselho-component 
                      :co-conselho="conselho.co_conselho"
                      :indicado="indicado"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CardCarregando from '@/modules/shared/components/CardCarregando';
import IndicacaoConselhoComponent from './components/IndicacaoConselhoComponent';
import moment from 'moment';
import codigosFase from '../../fase/utils/codigosFase';
import codigosConselho from '../utils/codigosConselho';

export default {
  name: 'IndicacaoConselho',

  components: {
    CardCarregando,
    IndicacaoConselhoComponent,
  },

  data() {
    return {
      codigosFase,
      codigosConselho,
      loading: true,
      usuarioLogado: {},
      indicadosConselho: [
        {
          co_indicado_conselho: null,
          nu_cpf: '',
          no_nome: '',
          no_nome_votacao: '',
          uf: {},
        },
        {
          co_indicado_conselho: null,
          nu_cpf: '',
          no_nome: '',
          no_nome_votacao: '',
          uf: {},
        },
        {
          co_indicado_conselho: null,
          nu_cpf: '',
          no_nome: '',
          no_nome_votacao: '',
          uf: {},
        },
        {
          co_indicado_conselho: null,
          nu_cpf: '',
          no_nome: '',
          no_nome_votacao: '',
          uf: {},
        },
        {
          co_indicado_conselho: null,
          nu_cpf: '',
          no_nome: '',
          no_nome_votacao: '',
          uf: {},
        },
      ],
      tabs: null,

    };
  },

  watch: {
    fases() {
      this.checkIndicacaoEditavel();
    },
    usuario(valor) {
      this.usuarioLogado = valor;
    },
    usuarioLogado(usuario) {
      if (this.checkUsuario()) {
        this.obterDadosConselho(usuario.co_conselho);
      }
    },
    conselho(conselho){
      this.obterDadosHabilitacaoConselho(conselho.co_conselho);
      this.obterIndicadosPorConselho(conselho.co_conselho);
    },
    habilitacaoConselho() {
      this.checkConselhoHabilitado();
    },
    indicadosConselhoGetter(indicados) {
      this.resolveIndicadosConselho(indicados);
      this.loading = false;
    },
  },

  computed: {
    ...mapGetters({
      perfil: 'conta/perfil',
      usuario: 'conta/usuario',

      fases: 'fase/fases',
      ativarIndicacaoConselho: 'fase/ativarIndicacaoConselho',

      conselho: 'conselho/conselho',
      habilitacaoConselho: 'conselho/habilitacaoConselho',
      indicadosConselhoGetter: 'conselho/indicadosConselho',

    }),
  },

  methods: {
    ...mapActions({
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',

      obterUsuarioLogado: 'conta/tratarUsuarioLogado',

      obterFases: 'fase/obterFases',
      obterEstados: 'localidade/obterEstados',

      obterDadosConselho: 'conselho/obterDadosConselho',
      obterDadosHabilitacaoConselho: 'conselho/obterDadosHabilitacaoConselho',
      obterIndicadosPorConselho: 'conselho/obterIndicadosPorConselho',
    }),
    checkIndicacaoEditavel() {
      if (!this.iniciadoPeriodoIndicacao()) {
        this.definirMensagemErro('Indicação de Representantes Indisponível!');
        this.$router.push('/').catch(() => {});
      }
    },
    checkUsuario() {
      if (this.perfil.no_perfil != 'conselho') {
        this.definirMensagemErro('Conselho de Cultura não associado ao perfil');
        this.$router.push('/').catch(() => {});
        return false;
      }
      return true;
    },
    checkConselhoHabilitado() {
      if (!this.habilitacaoConselho.st_habilitacao == codigosConselho.HABILITADO) {
        this.definirMensagemErro('Conselho de Cultura não habilitado para fase de Indicação');
        this.$router.push('/').catch(() => {});
      }
    },
    iniciadoPeriodoIndicacao() {
      let faseIndicacaoConselho = {};
      faseIndicacaoConselho = this.fases.find(f => f.tp_fase == codigosFase.TP_INDICACAO_CONSELHO);
      const dataInicio = moment(faseIndicacaoConselho.dh_inicio).toDate().getTime();
      const dataAtual = moment().toDate().getTime();

      return dataAtual >= dataInicio;
    },
    resolveIndicadosConselho(indicados) {
      indicados.forEach((indicado,index) => this.indicadosConselho.splice(index,1,indicado));
      if (!this.ativarIndicacaoConselho) {
        this.indicadosConselho = this.indicadosConselho.filter(indicado => !indicado.co_indicado_conselho);
      }
    },
  },
  mounted() {
    if (this.fases && this.fases.length > 0) {
      this.checkIndicacaoEditavel();
    }
    this.obterUsuarioLogado();
    this.obterEstados();

    this.usuarioLogado = this.usuario;
  },
};
</script>
